import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Youtube, Instagram } from 'lucide-react';
import AdSenseAd from './AdSenseAd';

const Footer = () => {
  return (
    <footer className="bg-[#001f3f] text-white mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_b421cab0-afec-4d5c-8996-440a4a24e0cf/artifacts/fy51jndf_IMG_4650.jpeg" 
              alt="SheLovesThee Logo" 
              className="h-12 mb-4"
            />
            <p className="text-sm text-slate-300">
              Your #1 source for SWAC sports and HBCU news, with emphasis on Jackson State football.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold uppercase tracking-wider mb-4 heading-font">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/news" className="text-sm text-slate-300 hover:text-[#DC2626] transition-colors">News</Link></li>
              <li><Link to="/fan-zone" className="text-sm text-slate-300 hover:text-[#DC2626] transition-colors">Polls</Link></li>
              <li><Link to="/predictions" className="text-sm text-slate-300 hover:text-[#DC2626] transition-colors">Predictions</Link></li>
              <li><Link to="/qb-club" className="text-sm text-slate-300 hover:text-[#DC2626] transition-colors">QB Club</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold uppercase tracking-wider mb-4 heading-font">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=100089106589635" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-[#DC2626] transition-colors" aria-label="Facebook" data-testid="social-facebook">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="https://x.com/SheLoves_Thee" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-[#DC2626] transition-colors" aria-label="Twitter" data-testid="social-twitter">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="https://www.youtube.com/@SheLoves_Thee" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-[#DC2626] transition-colors" aria-label="YouTube" data-testid="social-youtube">
                <Youtube className="h-6 w-6" />
              </a>
              <a href="https://www.instagram.com/sheloves_thee" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-[#DC2626] transition-colors" aria-label="Instagram" data-testid="social-instagram">
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold uppercase tracking-wider mb-4 heading-font">Advertisement</h3>
            <AdSenseAd 
              adSlot="3019687562"
              adFormat="rectangle"
              style={{ width: '300px', height: '250px' }}
            />
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-sm text-slate-400 mb-2">
            © 2026 SheLovesThee Podcast. All rights reserved.
          </p>
          <div className="flex justify-center space-x-4 text-sm">
            <Link to="/privacy" className="text-slate-400 hover:text-[#DC2626] transition-colors">
              Privacy Policy
            </Link>
            <span className="text-slate-600">|</span>
            <Link to="/terms" className="text-slate-400 hover:text-[#DC2626] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;